// src/app/modules/Members/pages/members-table/column-formatters/DepartmentUnitFormatter.jsx
// Shows department for staff or unit number for residents

import React from "react";
import { Building2, Home } from 'lucide-react';

export function DepartmentUnitFormatter(cellContent, row, hasFeature) {
  if (row.member_type === 'staff' || row.role === 'security') {
    if (!row.department && !row.space_name) {
      return <span className="sety-tbl-sub">—</span>;
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} className="sety-tbl-sub">
        <Building2 size={14} />{row.department || row.space_name}
      </div>
    );
  }

  if (hasFeature('hasResidents') && (row.member_type === 'resident' || row.member_type === 'user')) {
    if (!row.space_name) {
      return <span className="sety-tbl-sub">—</span>;
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }} className="sety-tbl-sub">
        <Home size={14} />{row.space_name}
      </div>
    );
  }

  return <span className="sety-tbl-sub">—</span>;
}
